/* src/app/home-new/finishing-settings-section/finishing-settings-section.component.scss */
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #949494;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #b7b7b7;
}
:host {
  width: 100%;
}
h1 {
  color: white;
  font-size: 24px;
  font-weight: 600;
}
.scrollable {
  overflow-y: auto;
  padding-left: 7px;
  direction: rtl;
  margin-bottom: 10px;
}
.scrollable::-webkit-scrollbar {
  width: 5px;
  background: #f6f6f6;
}
.scrollable::-webkit-scrollbar-thumb {
  background: #f5b200;
}
.scrollable::-webkit-scrollbar-track {
  background: #f6f6f6;
}
.scrollable .ltr {
  direction: ltr;
}
.container {
  border-radius: 15px;
  background: white;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1019607843);
}
ion-button {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 600;
  font-size: 20px;
}
ion-button ion-icon {
  margin-right: 10px;
}
.fixed-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 27rem;
  background-color: #f6f6f6;
  box-shadow: 0 -4px 10px 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding: 10px 20px 30px 15px;
}
.floatting {
  background: #47494b;
  position: fixed;
  right: 0px;
  left: 0px;
  padding: 15px;
  height: 200px;
  z-index: 99;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.5);
}
@media (max-width: 1300px) {
  ion-button {
    font-size: 16px;
  }
}
@media (max-width: 1104px) {
  ion-button {
    font-size: 14px;
  }
}
.goToFinishingButton {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  --background: #f5b200;
  --background-hover: #ffbd08;
  --background-activated: #f5b200;
}
.goToFinishingButton .button-content {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 5rem;
}
.goToFinishingButton .arrow-icon {
  color: #f6f6f6;
  transform: scale(1.5);
}
.goToFinishingButton .span-content {
  color: #f6f6f6;
}
.goToFinishingButton .finishing-icon {
  width: 1.5rem;
  height: 1.5rem;
  color: #37373e;
}
.goToFinishingButtonMobile {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  --background: #f5b200;
  --background-hover: #ffbd08;
  --background-activated: #f5b200;
  color: #37373e;
}
/*# sourceMappingURL=finishing-settings-section.component-MOAIY5TV.css.map */
